var _circle, _line, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgRoleTransitionEnabledIcon = function SvgRoleTransitionEnabledIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 13.5,
    fill: "white",
    stroke: "#4C9151"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 17.9467,
    y1: 8.2311,
    x2: 9.94301,
    y2: 19.7769,
    stroke: "#4C9151",
    strokeWidth: 1.76938,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.16485 12.6403C9.25199 12.748 9.40832 12.7625 9.51276 12.6727C9.61784 12.5821 9.63258 12.4215 9.5448 12.3132L7.56687 9.86605L9.54544 7.41894C9.63258 7.31056 9.61848 7.14997 9.5134 7.05944C9.40832 6.9689 9.25263 6.98344 9.16549 7.09182L7.05493 9.70216C7.01648 9.74974 6.99726 9.8079 6.99726 9.86605C6.99726 9.92421 7.01648 9.98236 7.05493 10.0293L9.16485 12.6403Z",
    stroke: "#4C9151",
    strokeWidth: 0.88469
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7709 9.86328H7.95272",
    stroke: "#4C9151",
    strokeWidth: 1.76938,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6043 15.0462C18.5171 14.9385 18.3608 14.924 18.2564 15.0139C18.1513 15.1044 18.1366 15.265 18.2243 15.3734L20.2023 17.8205L18.2237 20.2676C18.1366 20.376 18.1507 20.5365 18.2557 20.6271C18.3608 20.7176 18.5165 20.7031 18.6036 20.5947L20.7142 17.9844C20.7527 17.9368 20.7719 17.8786 20.7719 17.8205C20.7719 17.7623 20.7527 17.7042 20.7142 17.6572L18.6043 15.0462Z",
    stroke: "#4C9151",
    strokeWidth: 0.88469
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.908 17.8184L19.7262 17.8184",
    stroke: "#4C9151",
    strokeWidth: 1.76938,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRoleTransitionEnabledIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/role-transition-enabled-icon.46d47297c61fb2192a9f73fb6e060c45.svg";